import jsPDF from 'jspdf';
import 'jspdf-autotable'
import { XMLParser } from 'fast-xml-parser';


const getArray = (obj, key) => {
    if (Array.isArray(obj?.[key])) {
        return obj[key];
    } else if (obj?.[key]) {
        return [obj[key]];
    } else {
        return [];
    }
};



const convertUBLToUnifiedJSON = (parsedData) => {
    const invoice = parsedData.Invoice;

    const extractFieldIfNull = (primary, secondary) => primary || secondary;

    const unifiedJSON = {
        supplier: {
            name: extractFieldIfNull(
                extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PartyName']?.['cbc:Name']),
                extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PartyLegalEntity']?.['cbc:RegistrationName'])
            ),
            address: {
                street: extractFieldIfNull(
                    extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:StreetName']),
                    extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PostalAddress']?.['cac:AddressLine']?.['cbc:Line'])
                ),
                city: extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:CityName']),
                postalCode: extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:PostalZone']),
                country: extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PostalAddress']?.['cac:Country']?.['cbc:IdentificationCode']),
            },
            taxId: extractFieldValue(invoice?.['cac:AccountingSupplierParty']?.['cac:Party']?.['cac:PartyTaxScheme']?.['cbc:CompanyID']),
        },
        customer: {
            name: extractFieldIfNull(
                extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PartyName']?.['cbc:Name']),
                extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PartyLegalEntity']?.['cbc:RegistrationName'])
            ),
            address: {
                street: extractFieldIfNull(
                    extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:StreetName']),
                    extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PostalAddress']?.['cac:AddressLine']?.['cbc:Line'])
                ),
                city: extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:CityName']),
                postalCode: extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PostalAddress']?.['cbc:PostalZone']),
                country: extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PostalAddress']?.['cac:Country']?.['cbc:IdentificationCode']),
            },
            taxId: extractFieldValue(invoice?.['cac:AccountingCustomerParty']?.['cac:Party']?.['cac:PartyTaxScheme']?.['cbc:CompanyID']),
        },
        invoiceDetails: {
            id: extractFieldValue(invoice?.['cbc:ID']),
            issueDate: extractFieldValue(invoice?.['cbc:IssueDate']),
            typeCode: extractFieldValue(invoice?.['cbc:InvoiceTypeCode']),
            currency: extractFieldValue(invoice?.['cbc:DocumentCurrencyCode']),
            paymentDueDate: extractFieldValue(invoice?.['cbc:DueDate']),
            paymentMeans: extractFieldValue(invoice?.['cac:PaymentMeans']?.['cbc:PaymentMeansCode']),
        },
        items: getArray(invoice, 'cac:InvoiceLine').map((item) => ({
            name: extractFieldIfNull(
                extractFieldValue(item?.['cac:Item']?.['cbc:Name']),
                extractFieldValue(item?.['cac:Item']?.['cbc:Description'])
            ),
            quantity: extractFieldValue(item?.['cbc:InvoicedQuantity']?.['#text']),
            unitCode: extractFieldValue(item?.['cbc:InvoicedQuantity']?.['@_unitCode']),
            unitPrice: extractFieldValue(item?.['cac:Price']?.['cbc:PriceAmount']?.['#text']),
            currency: extractFieldValue(item?.['cac:Price']?.['cbc:PriceAmount']?.['@_currencyID']),
            lineExtensionAmount: extractFieldValue(item?.['cbc:LineExtensionAmount']?.['#text']),
            lineExtensionCurrency: extractFieldValue(item?.['cbc:LineExtensionAmount']?.['@_currencyID']),
            taxCategory: extractFieldIfNull(
                extractFieldValue(item?.['cac:Item']?.['cac:ClassifiedTaxCategory']?.['cac:TaxScheme']?.['cbc:ID']),
                extractFieldValue(item?.['cac:TaxTotal']?.['cac:TaxSubtotal']?.['cac:TaxCategory']?.['cac:TaxScheme']?.['cbc:ID'])
            ),
        })) || [],
        totals: {
            lineExtensionAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:LineExtensionAmount']?.['#text']),
            lineExtensionCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:LineExtensionAmount']?.['@_currencyID']),
            taxExclusiveAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:TaxExclusiveAmount']?.['#text']),
            taxExclusiveCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:TaxExclusiveAmount']?.['@_currencyID']),
            taxInclusiveAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:TaxInclusiveAmount']?.['#text']),
            taxInclusiveCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:TaxInclusiveAmount']?.['@_currencyID']),
            allowanceTotalAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:AllowanceTotalAmount']?.['#text']),
            allowanceCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:AllowanceTotalAmount']?.['@_currencyID']),
            chargeTotalAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:ChargeTotalAmount']?.['#text']),
            chargeCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:ChargeTotalAmount']?.['@_currencyID']),
            prepaidAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PrepaidAmount']?.['#text']),
            prepaidCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PrepaidAmount']?.['@_currencyID']),
            payableRoundingAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PayableRoundingAmount']?.['#text']),
            payableRoundingCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PayableRoundingAmount']?.['@_currencyID']),
            payableAmount: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PayableAmount']?.['#text']),
            payableCurrency: extractFieldValue(invoice?.['cac:LegalMonetaryTotal']?.['cbc:PayableAmount']?.['@_currencyID']),
            taxAmount: extractFieldValue(invoice?.['cac:TaxTotal']?.['cbc:TaxAmount']?.['#text']),
            taxCurrency: extractFieldValue(invoice?.['cac:TaxTotal']?.['cbc:TaxAmount']?.['@_currencyID']),
            vatPercentage: extractFieldValue(invoice?.['cac:TaxTotal']?.['cac:TaxSubtotal']?.['cac:TaxCategory']?.['cbc:Percent']),
        },
    };

    return unifiedJSON;
};


const generatePDF = (invoiceData) => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text('Invoice', 105, 20, { align: 'center' });

    // Adjust margins
    let yPosition = 30;

    // Add supplier details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Supplier:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.supplier?.name ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Address:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    const supplierAddress = [
        invoiceData.supplier?.address?.street ?? '',
        invoiceData.supplier?.address?.city ?? '',
        invoiceData.supplier?.address?.postalCode ?? '',
        invoiceData.supplier?.address?.country ?? ''
    ].filter(line => line).join('\n');
    doc.text(supplierAddress, 60, yPosition);
    // yPosition += supplierAddress.split('\n').length * 10;
    yPosition += 20;
    doc.setFont('helvetica', 'bold');
    doc.text('Tax ID:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.supplier?.taxId ?? '', 60, yPosition);
    yPosition += 20;

    // Add customer details
    doc.setFont('helvetica', 'bold');
    doc.text('Customer:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.customer?.name ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Address:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    const customerAddress = [
        invoiceData.customer?.address?.street ?? '',
        invoiceData.customer?.address?.city ?? '',
        invoiceData.customer?.address?.postalCode ?? '',
        invoiceData.customer?.address?.country ?? ''
    ].filter(line => line).join('\n');
    doc.text(customerAddress, 60, yPosition);
    yPosition += 20;
    doc.setFont('helvetica', 'bold');
    doc.text('Tax ID:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.customer?.taxId ?? '', 60, yPosition);
    yPosition += 20;

    // Add invoice details
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice ID:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.invoiceDetails?.id?.toString() ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Issue Date:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.invoiceDetails?.issueDate ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Type Code:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.invoiceDetails?.typeCode?.toString() ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Currency:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.invoiceDetails?.currency ?? '', 60, yPosition);
    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Payment Means:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.invoiceDetails?.paymentMeans?.toString() ?? '', 60, yPosition);
    yPosition += 20;

    // Add items table
    doc.setFont('helvetica', 'bold');
    doc.text('Items:', 20, yPosition);
    yPosition += 10;
    doc.autoTable({
        startY: yPosition,
        head: [['Description', 'Quantity', 'Unit Price', 'Total']],
        body: invoiceData.items.map(item => [
            item.name ?? '',
            item.quantity?.toString() ?? '',
            `${item.unitPrice ?? ''} ${item.currency ?? ''}`,
            `${item.lineExtensionAmount ?? ''} ${item.lineExtensionCurrency ?? ''}`
        ]),
        styles: { halign: 'center' },
        headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
        margin: { top: 10 }
    });

    // Calculate the position of the next section
    yPosition = doc.lastAutoTable.finalY + 10;

    // Check if there's enough space for the totals, otherwise add a new page
    if (yPosition + 80 > doc.internal.pageSize.height - 20) {
        doc.addPage();
        yPosition = 20;
    }

    // Add totals
    doc.setFont('helvetica', 'bold');
    doc.text('Totals:', 20, yPosition);
    doc.setFont('helvetica', 'normal');
    yPosition += 10;

    // Function to add total if defined
    const addTotalIfDefined = (label, value, currency, yPos) => {
        if (value !== undefined) {
            doc.text(`${label}: ${value} ${currency}`, 20, yPos);
            return yPos + 10;
        }
        return yPos;
    };

    // Add only defined totals
    yPosition = addTotalIfDefined('Line Extension Amount', invoiceData.totals.lineExtensionAmount, invoiceData.totals.lineExtensionCurrency, yPosition);
    yPosition = addTotalIfDefined('Tax Exclusive Amount', invoiceData.totals.taxExclusiveAmount, invoiceData.totals.taxExclusiveCurrency, yPosition);
    yPosition = addTotalIfDefined('Tax Inclusive Amount', invoiceData.totals.taxInclusiveAmount, invoiceData.totals.taxInclusiveCurrency, yPosition);
    yPosition = addTotalIfDefined('Tax Rate', invoiceData.totals.vatPercentage, '%', yPosition);
    yPosition = addTotalIfDefined('Allowance Total Amount', invoiceData.totals.allowanceTotalAmount, invoiceData.totals.allowanceCurrency, yPosition);
    yPosition = addTotalIfDefined('Charge Total Amount', invoiceData.totals.chargeTotalAmount, invoiceData.totals.chargeCurrency, yPosition);
    yPosition = addTotalIfDefined('Prepaid Amount', invoiceData.totals.prepaidAmount, invoiceData.totals.prepaidCurrency, yPosition);
    yPosition = addTotalIfDefined('Payable Rounding Amount', invoiceData.totals.payableRoundingAmount, invoiceData.totals.payableRoundingCurrency, yPosition);
    yPosition = addTotalIfDefined('Payable Amount', invoiceData.totals.payableAmount, invoiceData.totals.payableCurrency, yPosition);

    return doc;
};




const findKey = (obj, keyToFind) => {
    // return value for specific key in deep json
    if (typeof obj !== 'object' || obj === null) {
        return null;
    }

    for (const key in obj) {
        if (key === keyToFind) {
            return obj[key];
        }
        const result = findKey(obj[key], keyToFind);
        if (result !== null) {
            return result;
        }
    }
    return null;
};


const extractFieldValue = (field) => {
    // get field value if it is plain text or it is object with #text key
    if (typeof field === 'object' && '#text' in field) {
        return field['#text'];
    } else {
        return field;
    }
};


function isEmpty(value) {
    return value === null || value === undefined || value === '';
  }
  
  function checkIfAllValuesAreEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (typeof value === 'object' && value !== null) {
          if (!checkIfAllValuesAreEmpty(value)) {
            return false;
          }
        } else if (!isEmpty(value)) {
          return false;
        }
      }
    }
    return true;
  }


export const processData = (jsonObj, exportEmbeddedDoc) => {
    // exportEmbeddedDoc - bool; if true, try to find and use embedded document

    var einvoiceJson = null
    // if the imported xml file doesnt have invoice field, check if it has document.document (I had such example from Malaysia)
    if (!jsonObj.hasOwnProperty('invoice') && jsonObj.hasOwnProperty('document') && jsonObj.document.hasOwnProperty('document')) {
        const options = {
            ignoreAttributes: false,
            attributeNamePrefix: "@_"
        };
        const parser = new XMLParser(options);
        einvoiceJson = parser.parse(jsonObj.document.document);
    } else {
        einvoiceJson = jsonObj
    }


    var errorMsg = null
    var base64File = null
    var unifiedJSON = null
    var base64FileObject = null

    if (exportEmbeddedDoc) {
        // check for embedded document. ZUGFeRD or UBL
        base64FileObject = findKey(einvoiceJson, 'cbc:EmbeddedDocumentBinaryObject')
    }

    if (base64FileObject) {
        base64File = extractFieldValue(base64FileObject)
    } else {
        unifiedJSON = convertUBLToUnifiedJSON(einvoiceJson)
    }

    // console.log(einvoiceJson)
    // console.log(unifiedJSON)

    if (base64File) {
        // If base64 content is provided, return it as a Blob
        const byteCharacters = atob(base64File);
        const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        return [new Blob([byteArray], { type: 'application/pdf' }), errorMsg];
    } else {
        // otherwise processing logic using jsPDF
        const allValuesEmpty = checkIfAllValuesAreEmpty(unifiedJSON);
        if (allValuesEmpty) {
            errorMsg = 'Error. Unknown e-invoice format.'
        }
        const doc = generatePDF(unifiedJSON)
        return [doc.output('blob'), errorMsg];
    }
};
